import { Button, Typography } from "@mui/material";
import { JerseyAvatar } from "../heat/JerseyAvatar";
import { ChevronRight } from "@mui/icons-material";
import { makeStyles } from "../../providers/makeStyles";

export const AthleteSummary = ({ entry }) =>
    <VisualListContent icon={<JerseyAvatar src={entry.image} alt={entry.name} avatarProps={{ size: "lg" }}/>} text={entry.name}/>;

export const AthleteButton = ({ name, image, subtext, disabled, onClick }) =>
    <VisualListButton
        icon={<JerseyAvatar src={image} alt={name} avatarProps={{ size: "lg" }}/>}
        text={name}
        subtext={subtext}
        disabled={disabled}
        onClick={onClick}
        aside={<ChevronRight/>}
    />;

const useStyles = makeStyles(theme => ({
    button: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "flex-start",
        padding: theme.spacing(1, 2)
    },
    aside: {
        display: "flex",
        marginLeft: "auto"
    }
}));
export const VisualListButton = ({ icon, text, subtext, aside, disabled, onClick }) => {
    const classes = useStyles();

    return (
        <Button className={classes.button} variant="outlined" disabled={disabled} onClick={onClick}>
            <VisualListContent icon={icon} text={text} subtext={subtext}/>
            {aside && <aside className={classes.aside}>{aside}</aside>}
        </Button>
    );
};

const useContentStyles = makeStyles(theme => ({
    box: {
        display: "flex",
        alignItems: "center",
    },
    icon: {
        color: "unset",
        marginRight: theme.spacing(1),
        display: "flex",
        "&& > *": {
            width: 44,
            height: 44,
        }
    },
    text: {
        textAlign: "left"
    }
}));
export const VisualListContent = ({ icon, text, subtext }) => {
    const classes = useContentStyles();

    return (
        <div className={classes.box}>
            {icon && <section className={classes.icon}>{icon}</section>}
            <section className={classes.text}>
                <Typography variant="button" component="p">{text}</Typography>
                {subtext && <Typography variant="caption" color="textSecondary">{subtext}</Typography>}
            </section>
        </div>
    );
};
